export enum CellDataType {
  Text = 'text',
  Integer = 'number',
  Date = 'date',
}
